import React from 'react'

import logo from '../assets/images/logo.svg'

import Menu from './Menu'

const Header = () => (
    <header>
        <section className="header">
            <div className="logo">
                <div className="logo-image">
                    <img src={logo} alt="Grafični studio" />
                    <div id="tagline" className="d-none d-sm-block">
                        Roža vetrov d.o.o.
                    </div>
                </div>
                <div className="header-contact">
                    <a
                        href="https://twitter.com/robertkuzma"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="fab fa-twitter" />
                    </a>
                    <a
                        href="https://www.facebook.com/graficnistudio"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="fab fa-facebook-f" />
                    </a>
                    <a
                        href="http://www.linkedin.com/in/robertkuzma"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="fab fa-linkedin-in" />
                    </a>
                    <a href="http://www.robertkuzma.com" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-rss" />
                    </a>
                    <a href="tel:+386 41 721 046">
                        <i className="fas fa-phone" /> +386 41 721 046
                    </a>
                </div>
            </div>
        </section>
        <Menu />
    </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js